export class FormatAddressFilter {
    public static $name: string = 'formatAddress';
    public static $inject: string[] = ['lodash'];

    public static Factory() {
        let factoryFunction = (lodash: _.LoDashStatic) => {
            return (address: CASLink.Device.Ui.ViewModel.Modules.AddressSearchResultViewModel) => {
                if (address) {
                    return [address.street1, address.street2, address.city, address.state, address.countryName]
                        .filter((val: string) => !lodash.isUndefined(val))
                        .join(', ');
                }
            };
        };

        factoryFunction.$inject = ['lodash'];

        return factoryFunction;
    }
}
